export default __webpack_public_path__ + "static/media/slide4.b114ace5.png";